import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../seo/Seo";
import { SITE } from "../seo/states";
import { getCategory, postsByCategory } from "../seo/blog";
import { PageShell } from "../components/PageShell";

export default function BlogCategory() {
  const { catSlug } = useParams();
  const cat = getCategory(catSlug);
  if (!cat) return <Navigate to="/blog" replace />;
  const posts = postsByCategory(catSlug);
  const url = `${SITE}/blog/category/${cat.slug}`;

  return (
    <PageShell
      eyebrow="Blog Category"
      title={cat.name}
      subtitle={cat.desc}
      breadcrumb={[{ label: "Home", to: "/" }, { label: "Blog", to: "/blog" }, { label: cat.name }]}
    >
      <Seo title={`${cat.name} Articles | Alexa Financial Blog`} description={cat.desc} canonical={url} keywords={`${cat.name}, ${cat.slug.replace(/-/g, " ")}`} />
      <section className="py-16 md:py-20 bg-[#050505]">
        <div className="max-w-[1000px] mx-auto px-5 md:px-10 space-y-5">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`cat-post-${p.slug}`} className="group block glass rounded-2xl p-7 hover:border-[#d4af37]/40 transition-colors">
              <h2 className="font-display text-2xl text-white group-hover:text-[#e9d08a] transition-colors">{p.title}</h2>
              <p className="mt-2 text-[#a3a3a3]">{p.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#d4af37]">Read article <ArrowUpRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
